import { SmrStayState } from '@/store/modules/stay/smr/types'

export const state = new SmrStayState()